const single_sign_on = {
    forbidden_domains: 'Недопустимы публичные домены электронной почты.',
    duplicated_domains: 'Есть дублирующиеся домены.',
    invalid_domain_format: 'Недопустимый формат домена.',
    duplicate_connector_name: 'Имя коннектора уже существует. Пожалуйста, выберите другое имя.',
};
export default Object.freeze(single_sign_on);
